module.exports = __webpack_public_path__ + "media/bootstrap-icons/menu-button-dfdcf63d.svg";